import React, {useState, useEffect} from 'react';
import {Container,Row,Col} from 'react-bootstrap'
import {useParams} from 'react-router-dom';
import getProductById from '../hooks/getProductById';
import ProductosRelacionados from '../Components/ProductosRelacionados'
import '../Styles/producto.css'
import sendWsppProd from '../hooks/sendWsppProd'

const Producto = ({titulo}) => {

    const micategoria = `${titulo}`;

    const {id} = useParams();
    const [productInfo, setProductInfo] = useState('');
      useEffect(() => {
        async function getProductInfo() {
            const product = await getProductById(id);
            setProductInfo(product);
            
        }
         getProductInfo();
        
    }, [id]);

    //console.log(productInfo)
    //miFunction(id);
    return (
        <>    
        
            
            {
                productInfo.length > 0 ? (
                    productInfo.map(item => (
                        <>
                        <Container fuild="100%" className="productoContainer" id="mi_producto">
                            <Row>
                                <Col>
                                    <div className="productoImagen">
                                        <img alt='productoImagen' src={`${item.imagen}`}/> 
                                    </div>                                
                                </Col>
                                
                                <Col>
                                    <div className="productoDetalles">
                                       
                                        <div className="productoCategoria">{item.categoria}-{item.id}</div>    
                                        <div className="productoTitulo">{item.nombre}</div>  
                                        
                                        <div className="productoPrecio"> S/ {item.precio}.00 x und</div>  
                                        <div className="productoDescripcion"><b>Descripcion:</b> {item.descripcion}</div>                              
                                        <div className="productoMedidas">Alto: {item.altura}cm | Ancho: {item.anchura}cm</div>
                                    
                                        <button className="botonWspp" onClick={() => sendWsppProd(item,micategoria)}>Comprar Producto</button>
                                    </div>
                                </Col>      
                            </Row>                      
                        </Container>
                        </>
                        
                    ))):(
                        
                        <p> No hay productos</p>
                    )
                
            }
        
        
        <div className="productosRelacionados">
        {
          {
            'Alabastro':
              <>
                <ProductosRelacionados titulo="Más artículos de Alabastro" query_data="alabastro"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="manteleria"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="murano"/>
              </>,  
            'Cristal':
              <>
                <ProductosRelacionados titulo="Más artículos de Crital" query_data="cristal"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="flores"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="manteleria"/>
              </>,
            'Flores':
              <>
                <ProductosRelacionados titulo="Más artículos de Flores" query_data="flores"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="cristal"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="vidrio"/>
              </>,
            'Manteleria':
              <>
                <ProductosRelacionados titulo="Más artículos de Mantelería" query_data="manteleria"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="cristal"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="alabastro"/>
              </>,
            'Murano':
              <>
                <ProductosRelacionados titulo="Más artículos de Murano" query_data="murano"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="manteleria"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="plaque"/>
              </>,
            'Navidad':
              <>
                <ProductosRelacionados titulo="Más artículos de Navidad" query_data="navidad"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="poliresina"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="manteleria"/>
              </>,
            'Plaque':
              <>
                <ProductosRelacionados titulo="Más artículos de Plaque" query_data="plaque"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="poliresina"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="porcelana"/>
              </>,
            'Poliresina':
              <>
                <ProductosRelacionados titulo="Más artículos de Poliresina" query_data="poliresina"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="manteleria"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="plaque"/>
              </>,
            'Porcelana':
              <>
                <ProductosRelacionados titulo="Más artículos de Porcelana" query_data="porcelana"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="cristal"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="vidrio"/>
              </>,
            'Vidrio':
              <>
                <ProductosRelacionados titulo="Más artículos de Vidrio" query_data="vidrio"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="cristal"/>
                <ProductosRelacionados titulo="Quizás te guste" query_data="flores"/>
              </>
          }[micategoria]

        }
        </div>

        </>
          
  )
}

export default Producto